import { validateTidalLicense } from "../../base/index.js";
validateTidalLicense();
export * from "@workwave-tidal/foundation/javascript-utils/color";
//# sourceMappingURL=index.js.map
